import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["originalType", "mdxType", "parentName", "children"],
    _excluded2 = ["originalType", "mdxType", "parentName"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';
export default (function (props) {
  var arr = React.Children.toArray(props.children);
  var splits = [];
  var slides = [];
  slides.head = {
    props: {},
    children: []
  };
  var notes = {};
  arr.forEach(function (child, i) {
    var _child$props = child.props,
        originalType = _child$props.originalType,
        mdxType = _child$props.mdxType,
        parentName = _child$props.parentName,
        children = _child$props.children,
        childProps = _objectWithoutPropertiesLoose(_child$props, _excluded); // todo: figure out nested decks
    // if (originalType.isMDXComponent) {}
    // get notes


    if (originalType.__mdxDeck_notes || mdxType === 'Notes') {
      notes[splits.length] = children;
    } else if (originalType.__mdxDeck_header || mdxType === 'Header') {
      slides.header = children;
    } else if (originalType.__mdxDeck_footer || mdxType === 'Footer') {
      slides.footer = children; // get head content
    } else if (originalType.__mdxDeck_head || mdxType === 'Head') {
      slides.head.children.push(children);
      Object.assign(slides.head.props, childProps);
    }

    if (mdxType === 'hr') {
      splits.push(i);
    }
  });
  var previousSplit = 0;
  splits.forEach(function (split, i) {
    var children = _toConsumableArray(arr.slice(previousSplit, split));

    if (notes[i]) children.notes = notes[i];
    slides.push(children);
    previousSplit = split + 1;
  });

  var last = _toConsumableArray(arr.slice(previousSplit));

  if (notes[slides.length]) last.notes = notes[slides.length];
  slides.push(last);
  slides.head.children = React.Children.toArray(slides.head.children).map(function (child, i) {
    var _child$props2 = child.props,
        originalType = _child$props2.originalType,
        mdxType = _child$props2.mdxType,
        parentName = _child$props2.parentName,
        childProps = _objectWithoutPropertiesLoose(_child$props2, _excluded2);

    return /*#__PURE__*/React.createElement(originalType, _objectSpread({
      key: i
    }, childProps));
  });
  return slides;
});